import { render, staticRenderFns } from "./QuangCaoForm.vue?vue&type=template&id=09308b04&"
import script from "./QuangCaoForm.vue?vue&type=script&lang=js&"
export * from "./QuangCaoForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports